import React from 'react';
import { compose } from '@xo-union/react-css-modules';

import { ButtonDropdown, ButtonDropdownItem } from '../ButtonDropdown';
import LinkButton from '../LinkButton';
import styles from './rightRails.scss';

export interface HouseholdRailZeroStateContentProps {
  setGuestRailOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onAddEmailAddresses: Function;
  householdRailType: 'email' | 'phone';
}
interface Val {
  title: string;
  subText: string;
  icon: string;
}
export interface Copy {
  individualGuest: Val;
  bulkEmail: Val;
}
export const copy: Copy = {
  individualGuest: {
    title: 'Add one guest',
    subText: 'Individually add a name and address.',
    icon: 'add_circle',
  },
  bulkEmail: {
    title: 'Add multiple guests',
    subText: 'Add a group of email addresses at once.',
    icon: 'email_alternate',
  },
};

const classes = compose({
  buttonDropdownItem: styles.addGuestLinkItem,
  titleText: styles.titleText,
  subText: styles.subText,
});

const HouseholdRailZeroStateContent: React.FC<HouseholdRailZeroStateContentProps> = ({
  setGuestRailOpen,
  onAddEmailAddresses,
  householdRailType,
}) => {
  const addMethod = [
    {
      type: 'individualGuest',
    },
    {
      type: 'bulkEmail',
    },
  ];

  return (
    <div className={styles.zeroStateContainer}>
      <div className={styles.addGuestLink}>
        {householdRailType === 'phone' ? (
          <LinkButton className={styles.addGuestLinkSms} onClick={() => setGuestRailOpen(true)}>
            Add guests
          </LinkButton>
        ) : (
          <ButtonDropdown
            listClassName={styles.addGuestLinkList}
            text="Add guests"
            actionButton={true}
            size="lg"
            color="primary"
            carrotPosition="center"
            data-testid="zero-state-add-guests-button"
          >
            <div className={styles.addGuestDropdown}>
              {addMethod?.map(({ type }) => {
                return (
                  <ButtonDropdownItem
                    className={styles.addGuestLinkItem}
                    classes={classes}
                    key={type}
                    onClick={() => {
                      if (type === 'individualGuest') {
                        setGuestRailOpen(true);
                      } else {
                        onAddEmailAddresses();
                      }
                    }}
                    {...copy[type as keyof Copy]}
                  />
                );
              })}
            </div>
          </ButtonDropdown>
        )}
        <div className={styles.sendMessagesText}>&nbsp;to send messages</div>
      </div>
    </div>
  );
};

export default HouseholdRailZeroStateContent;
